import { css } from '@linaria/core';

export const textarea = css`
  height: auto;
  min-height: 65px;
  border-radius: 20px;
`;
